import InstagramCustomSettingsSchema from "@apps/instagram/schemas/InstagramCustomSettingsSchema";
import {
    Infer,
    boolean,
    instance,
    nullable,
    number,
    object,
    string,
    union,
} from "superstruct";

export const InstagramGalleryWidgetConfigSchema = object({
    galleryId: nullable(number()),
    galleryLayout: number(),
    isInstaPage: boolean(),
    productId: nullable(number()),
    target: union([string(), instance(HTMLElement)]),
    customSettings: InstagramCustomSettingsSchema,
});

export const InstagramGalleryWidgetConfigToken = Symbol(
    "InstagramGalleryWidgetConfigToken"
);

export type InstagramGalleryWidgetConfigInterface = Infer<
    typeof InstagramGalleryWidgetConfigSchema
>;
